import { withCatalogLayout } from "@/elements-react/catalog-layout/withCatalogLayout";
import { useWhatWeDoCommon } from "@/pages-react/what-we-do/WhatWeDoCommon.tsx";
import { LayoutStyleTypes } from "@/util-react/layout.tsx";

export const WhatWeDoDesktop = withCatalogLayout((props: { content: string }) => {
  const { renderContent } = useWhatWeDoCommon(props.content);

  return <>{renderContent()}</>;
}, LayoutStyleTypes.TYPE_LG);
